import { IFollowUpItem } from "us.collection.followup/interfaces";
import { SavedFiltersTabs } from "us.collection.followup/constants";
import _ from "lodash";

/**
 * @function
 * @description search followup in followupList
 * @param {Array<IFollowUpItem>} followups followup list
 * @param {string} searchText entered value
 * @returns {Object} filtered followups
 */
export const searchFollowup = (
  followups: Array<IFollowUpItem>,
  searchText: string
): {
  pinnedFollowup: Array<IFollowUpItem>;
  unpinnedFollowup: Array<IFollowUpItem>;
} => {
  try {
    const searchedFollowup = followups.filter((followup: IFollowUpItem) =>
      followup.followupDisplayName
        .toLowerCase()
        .includes(searchText.toLowerCase())
    );
    return {
      pinnedFollowup: searchedFollowup?.filter(
        ({ pinStatus }: any) => pinStatus
      ),
      unpinnedFollowup: searchedFollowup?.filter(
        ({ pinStatus }: any) => !pinStatus
      ),
    };
  } catch (error) {
    return { pinnedFollowup: [], unpinnedFollowup: [] };
  }
};

/**
 * @function
 * @description Retrieves the case handler ID for the current user based on their email.
 * @param {Array<any>} caseHandlers List of case handlers.
 * @param {string} currentUserEmail Email of the current user.
 * @returns {string} The case handler ID of the current user, or an empty string if not found.
 */
export const getCurrentUserCaseHandlerId = (
  caseHandlers: Array<any>,
  currentUserEmail: string
): string => {
  try {
    if (Array.isArray(caseHandlers)) {
      return (
        _?.find(caseHandlers, {
          email: currentUserEmail,
        })?.id?.toString() || ""
      );
    } else {
      return "";
    }
  } catch (error) {
    return "";
  }
};

/**
 * @function
 * @description Filters the saved follow-up filters based on the selected tab and the current user's email.
 * @param {Array<IFollowUpItem>} followupList List of follow-ups.
 * @param {string} currentUserEmail Email of the current user.
 * @param {string} savedFilterTab Selected saved filter tab.
 * @returns {Array<any>} Filtered list of follow-ups.
 */
export const filterSavedFollowUpFilters = (
  followupList: Array<IFollowUpItem>,
  currentUserEmail: string,
  savedFilterTab: string,
  caseHandlerList: Array<any>
): Array<IFollowUpItem> => {
  try {
    if (Array.isArray(followupList)) {
      switch (savedFilterTab) {
        case SavedFiltersTabs.CREATED:
          return followupList
            ?.filter(
              ({ isFilter, createdUser }) =>
                isFilter && createdUser == currentUserEmail
            )
            ?.sort((a, b) => a?.filterName?.localeCompare(b?.filterName));
        case SavedFiltersTabs.ASSIGNED:
          const currentUserCaseHandlerId = getCurrentUserCaseHandlerId(
            caseHandlerList,
            currentUserEmail
          );
          return followupList
            ?.filter(
              ({ isFilter, caseHandlers }) =>
                isFilter &&
                caseHandlers &&
                caseHandlers
                  ?.split(",")
                  .map((id: string) => id.trim())
                  .includes(currentUserCaseHandlerId)
            )
            ?.sort((a, b) => a?.filterName?.localeCompare(b?.filterName));
        default:
          return followupList
            ?.filter(({ isFilter }) => isFilter)
            ?.sort((a, b) => a?.filterName?.localeCompare(b?.filterName));
      }
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};
